import { TweenLite, Linear } from 'gsap'
import { addClass, removeClass, onResize, isMobile } from './utilities'
import { didScroll } from './portfolio/portfolio-item'

//const LANDSCAPE_CLASS = 'video-player--landscape';
const PORTRAIT_CLASS = 'video-player--potrait';

class VideoPlayer
{
  constructor()
  {
    this.container = document.querySelector('.video-player');
    this.isVisible = false;
    const closeBtn = this.container.querySelector('.video-player-close');
    closeBtn.addEventListener('click', (e)=>
    {
      e.preventDefault();

      if( isMobile() ){
        this.reset();
      }else{
        TweenLite.to( this.container, 0.5, {
          opacity: 0,
          ease: Linear.easeNone,
          onComplete: this.reset.bind(this)
        });
      }
    });
  }

  reset(){
    //console.log('reset');
    removeClass( this.container, PORTRAIT_CLASS );

    if( this.video ){
      this.container.removeChild( this.video );
      this.video = null;
    }

    this.container.style.visibility = 'hidden';
    document.body.style.overflow = 'initial';
    this.isVisible = false;
    didScroll( null );
  }

  showVideo( url, width, height )
  {
    //this.reset();

    this.container.style.visibility = 'visible';
    this.isVisible = true;
    didScroll( null );

    if( height > width ){
      addClass( this.container, PORTRAIT_CLASS );
    }
    //console.log( 'show video: ' + url + ' w: ' + width + ' h: ' + height );

    if( isMobile() ){
      this.addVideo( url, width, height );
    }else{
      TweenLite.fromTo( this.container, 0.5, {
        opacity: 0
      }, {
        opacity: 1,
        ease: Linear.easeNone,
        onComplete: () => {
          this.addVideo( url, width, height );
        }
      });
    }
  }

  addVideo( url, width, height )
  {
    const video = document.createElement('video');
    //video.setAttribute('loop','loop');
    video.setAttribute('controls','controls');
    //video.setAttribute('autoplay','autoplay');
    //video.setAttribute('playsinline','playsinline');
    const addSource = (src, type) => {
      var source = document.createElement( 'source' );
      source.src = src;
      source.type = type;
      video.appendChild( source );
    };
    addSource( url, 'video/mp4' );
    //addSource( '/video/masberenguer-intro.ogg', 'video/ogg' );
    //addSource( '/video/masberenguer-intro.webm', 'video/webm' );
    this.container.appendChild( video );
    video.addEventListener('webkitendfullscreen', this.reset.bind(this), false);
    video.play();

    this.video = video;
    this.videoWidth = width;
    this.videoHeight = height;
    onResize( this.doResize.bind(this) );
    document.body.style.overflow = 'hidden';

    TweenLite.fromTo( this.video, 0.5, {
      opacity: 0
    }, {
      opacity: 1,
      ease: Linear.easeNone
    });
  }

  doResize(){
    if( !this.video ){
      return;
    }

    this.video.style.width = window.innerWidth + 'px';
    this.video.style.height = window.innerHeight + 'px';
  }
}

const instance = new VideoPlayer();

export default instance;


/** WEBPACK FOOTER **
 ** ./src/js/video-player.js
 **/